import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Eye, EyeOff } from 'lucide-react';
import axiosInstance from '../../api/axios';

const OPTIONS = [
  { key: 'show_collections', label: 'Limited Collections & Themen-Boxen', hint: 'Kollektions-Bereiche und die beiden Kollektions-Kacheln im Saison-Bereich' },
  { key: 'show_seasonal_landing', label: 'Saison-Kollektionen (Landingpages)', hint: 'Karten der Saison-Landingpages auf der Startseite' },
];

export const HomepageVisibilityCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axiosInstance.get('/settings/homepage-visibility').then((r) => setData(r.data)).catch(() => {});
  }, []);

  const toggle = async (key) => {
    const next = { ...data, [key]: !data[key] };
    setData(next);
    try {
      await axiosInstance.put('/settings/homepage-visibility', next);
      toast.success(next[key] ? 'Auf der Startseite sichtbar' : 'Auf der Startseite ausgeblendet');
    } catch {
      setData(data);
      toast.error('Speichern fehlgeschlagen');
    }
  };

  if (!data) return null;
  return (
    <div className="bg-white border border-[#E8DED1] p-4 mb-6" data-testid="homepage-visibility-card">
      <h2 className="text-sm font-semibold text-[#5D4E3C] mb-1">Bereiche auf der Startseite</h2>
      <p className="text-xs text-gray-500 mb-3">Erst aktivieren, wenn die Kollektionen mit Bildern fertig angelegt sind.</p>
      {OPTIONS.map((o) => (
        <button
          key={o.key}
          type="button"
          onClick={() => toggle(o.key)}
          className="w-full flex items-center justify-between gap-3 py-2 border-t border-[#EFE6DA] text-left"
          data-testid={`homepage-visibility-${o.key}`}
        >
          <span>
            <span className="block text-sm text-[#5D4E3C]">{o.label}</span>
            <span className="block text-[11px] text-gray-500">{o.hint}</span>
          </span>
          <span className={`inline-flex items-center gap-1 px-2 py-1 text-xs ${data[o.key] ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'}`}>
            {data[o.key] ? <Eye className="h-3 w-3" /> : <EyeOff className="h-3 w-3" />}
            {data[o.key] ? 'Sichtbar' : 'Ausgeblendet'}
          </span>
        </button>
      ))}
    </div>
  );
};
